define([
    'angular',
    'angular-resource',
    '../../site/services/debug',
    '../services/loginCheck',
], function (angular) {
    return angular
        .module('profileServices', [
            'ngResource',
            'siteServices',
            'debugServices',
            'loginCheckServices',
        ])
        .factory('Profile', [
            '$http',
            '$interval',
            '$resource',
            '$rootScope',
            'Debug',
            'LoginCheck',
            function (
                $http,
                $interval,
                $resource,
                $rootScope,
                Debug,
                LoginCheck
            ) {
                var resource = $resource(
                    $rootScope.Routing.generate('profile_json', {
                        _format: 'json',
                    }),
                    [],
                    {
                        acceptCancelOffer: {
                            url: decodeURIComponent(
                                $rootScope.Routing.generate(
                                    'accept_cancel_offer',
                                    { _format: 'json' }
                                )
                            ),
                            method: 'POST',
                            isArray: false,
                        },
                        get: {
                            url: decodeURIComponent(
                                $rootScope.Routing.generate('profile_json', {
                                    _format: 'json',
                                })
                            ),
                            method: 'GET',
                            isArray: false,
                            transformResponse: function (data) {
                                var modelData = {};
                                try {
                                    modelData = JSON.parse(data);
                                } catch (e) {
                                    if (typeof Raven != 'undefined' && Raven) {
                                        Raven.captureException(e);
                                        Raven.captureException(
                                            new Error(
                                                'Cannot parse profile from get as json: ' +
                                                    data
                                            )
                                        );
                                    }
                                }
                                return modelData;
                            },
                        },
                        pauseAccount: {
                            url: decodeURIComponent(
                                $rootScope.Routing.generate('pause_account', {
                                    _format: 'json',
                                })
                            ),
                            method: 'POST',
                            isArray: false,
                        },
                        update: {
                            url: decodeURIComponent(
                                $rootScope.Routing.generate('profile_update', {
                                    _format: 'json',
                                })
                            ),
                            method: 'PUT',
                            isArray: false,
                            transformResponse: function (data) {
                                var modelData = {};
                                try {
                                    modelData = JSON.parse(data);
                                } catch (e) {
                                    if (typeof Raven != 'undefined' && Raven) {
                                        Raven.captureException(e);
                                        Raven.captureException(
                                            new Error(
                                                'Cannot parse profile from update as json: ' +
                                                    data
                                            )
                                        );
                                    }
                                }
                                return modelData;
                            },
                        },
                        updateCreditCard: {
                            url: decodeURIComponent(
                                $rootScope.Routing.generate(
                                    'profile_update_cc',
                                    { _format: 'json' }
                                )
                            ),
                            method: 'POST',
                            isArray: false,
                            transformResponse: function (data) {
                                var modelData = {};
                                if (data) {
                                    try {
                                        modelData = JSON.parse(data);
                                    } catch (e) {
                                        if (
                                            typeof Raven != 'undefined' &&
                                            Raven
                                        ) {
                                            Raven.captureException(e);
                                            Raven.captureException(
                                                new Error(
                                                    'Cannot parse profile from updateCreditCard as json: ' +
                                                        data
                                                )
                                            );
                                        }
                                    }
                                }
                                return modelData;
                            },
                        },
                        updatePassword: {
                            url: decodeURIComponent(
                                $rootScope.Routing.generate('password_update', {
                                    _format: 'json',
                                })
                            ),
                            method: 'POST',
                            isArray: false,
                            transformResponse: function (data) {
                                var modelData = {};
                                if (data) {
                                    try {
                                        modelData = JSON.parse(data);
                                    } catch (e) {
                                        if (
                                            typeof Raven != 'undefined' &&
                                            Raven
                                        ) {
                                            Raven.captureException(e);
                                            Raven.captureException(
                                                new Error(
                                                    'Cannot parse profile from updatePassword as json: ' +
                                                        data
                                                )
                                            );
                                        }
                                    }
                                }
                                return modelData;
                            },
                        },
                        checkDomain: {
                            url: decodeURIComponent(
                                $rootScope.Routing.generate('validate_domain', {
                                    _format: 'json',
                                })
                            ),
                            method: 'POST',
                            isArray: false,
                            transformResponse: function (data) {
                                var modelData = {};
                                try {
                                    modelData = JSON.parse(data);
                                } catch (e) {
                                    if (typeof Raven != 'undefined' && Raven) {
                                        Raven.captureException(e);
                                        Raven.captureException(
                                            new Error(
                                                'Cannot parse profile from checkDomain as json: ' +
                                                    data
                                            )
                                        );
                                    }
                                }
                                return modelData;
                            },
                        },
                        removeProfileLogo: {
                            url: decodeURIComponent(
                                $rootScope.Routing.generate(
                                    'delete_profile_logo',
                                    { _format: 'json' }
                                )
                            ),
                            method: 'DELETE',
                            isArray: false,
                            transformResponse: function (data) {
                                var modelData = {};
                                try {
                                    modelData = JSON.parse(data);
                                } catch (e) {
                                    if (typeof Raven != 'undefined' && Raven) {
                                        Raven.captureException(e);
                                        Raven.captureException(
                                            new Error(
                                                'Cannot parse profile from update as json: ' +
                                                    data
                                            )
                                        );
                                    }
                                }
                                return modelData;
                            },
                        },
                    }
                );

                // Prompt for re-login if the login has expired
                var loginCheck = $interval(function () {
                    $http({
                        method: 'GET',
                        url: $rootScope.Routing.generate('logged_in', {
                            _format: 'json',
                        }),
                    }).then(
                        function (response) {
                            if (!response.data.loggedIn) {
                                LoginCheck.alertNotLoggedIn();
                                $interval.cancel(loginCheck);
                            }
                        },
                        function (response) {
                            LoginCheck.alertNotLoggedIn();
                            $interval.cancel(loginCheck);
                        }
                    );
                }, 60 * 1000);

                var profile = false;
                var loadSettings = true;
                var domainCaches = {};
                /* Cache domain status for 5 minutes so we can keep it up to date but not
                 * send a ton of requests.
                 */
                var domainCacheTime = 5 * 60 * 1000;
                return {
                    acceptCancelOffer: function (offer) {
                        var request = resource.acceptCancelOffer({
                            offer: offer,
                        });
                        request.$promise.then(function () {
                            if (profile) {
                                profile.$get();
                            }
                        });

                        return request.$promise;
                    },
                    cancelAccount: function (cancellationReason) {
                        var request = $http.post(
                            $rootScope.Routing.generate('cancel_account', {
                                _format: 'json',
                            }),
                            {
                                reason: cancellationReason,
                            }
                        );

                        request.then(function () {
                            // Stop doing a login check, because it will always fail
                            $interval.cancel(loginCheck);
                        });

                        return request;
                    },
                    getProfile: function (reload, callback) {
                        if (!profile || reload || loadSettings) {
                            profile = resource.get();
                            loadSettings = false;

                            profile.$promise.then(
                                function (user) {
                                    if (
                                        typeof Raven != 'undefined' &&
                                        Raven &&
                                        user &&
                                        user.hasOwnProperty('email') &&
                                        user.hasOwnProperty('id')
                                    ) {
                                        Raven.setUserContext({
                                            email: user.email,
                                            id: user.id,
                                        });
                                    }
                                },
                                function (response) {
                                    LoginCheck.checkAuthError(response);

                                    // Log error responses
                                    Debug.log(response);
                                }
                            );
                        }
                        if (typeof callback == 'function') {
                            profile.$promise.then(callback);
                        }
                        return profile;
                    },
                    pauseAccount: function (pauseLength) {
                        var request = resource.pauseAccount({
                            pauseMonths: pauseLength,
                        });
                        request.$promise.then(function () {
                            if (profile) {
                                profile.$get();
                            }
                        });

                        return request.$promise;
                    },
                    updateCreditCard: function (newData) {
                        var request = resource.updateCreditCard(newData);
                        request.$promise.then(
                            function () {},
                            function (response) {
                                LoginCheck.checkAuthError(response);

                                // Log error responses
                                Debug.log(response);
                            }
                        );

                        return request;
                    },
                    checkDomain: function (domain, forceReload) {
                        if (
                            !domainCaches.hasOwnProperty(domain) ||
                            (domainCaches[domain] &&
                                domainCaches[domain].time + domainCacheTime <
                                    Date.now()) ||
                            forceReload
                        ) {
                            domainCaches[domain] = {
                                data: resource.checkDomain({ domain: domain }),
                                time: Date.now(),
                            };
                        }

                        domainCaches[domain].data.$promise.then(
                            function () {},
                            function (response) {
                                LoginCheck.checkAuthError(response);
                            }
                        );

                        return domainCaches[domain].data;
                    },
                };
            },
        ]);
});
